<template lang="pug">
  .TourQuizzQuestion(:class="{'is-valid': isValidated && isValid, 'is-validated': isValidated}" )
    p.TourQuizzQuestion_question {{ item.question }}

    .TourQuizzQuestion_answer(
      v-for="(r, index) in item.responses"
      @click="(e) => onClickAnswerHandler(e, index)"
      :data-index='index'
    ) {{ r }}

    transition(name="quizz-validation")
      .TourQuizzQuestion_validation(
        v-if="isValidated && item.explanations"
      )
        .TourQuizzQuestion_validation_wrapper
          p.TourQuizzQuestion_validation_title(v-if="isValid") {{$t('tour.quizz.good_answer_title')}}
          p.TourQuizzQuestion_validation_title(v-else) {{$t('tour.quizz.bad_answer_title')}}
          span.TourQuizzQuestion_validation_sep
          .TourQuizzQuestion_validation_desc {{item.explanations}}

</template>

<script>

export default {
  props: {
    'item': {
      type: Object,
      required: true
    },
    isValidated: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentAnswersIndex: []
    }
  },
  computed: {
    isValid () {
      this.currentAnswersIndex.sort()
      this.item.goodAnswer.sort()
      return this.currentAnswersIndex.join(',') == this.item.goodAnswer.join(',')
    }
  },
  methods: {
    onClickAnswerHandler (e, index) {
      e.preventDefault()
      e.currentTarget.classList.toggle('is-selected')

      this.currentAnswersIndex = []
      this.$el.querySelectorAll('.is-selected').forEach((el) => {
        this.currentAnswersIndex.push(parseInt(el.dataset.index))
      })
    }
  }
}
</script>

<style lang="stylus" scoped>

.TourQuizzQuestion
  box-sizing border-box
  width 100%
  padding 10px 0 10px 20px
  border-left 2px solid #4D483E
  position: relative

  @media $mq_m
    padding 10px 45px
    border-left-width 5px

  @media $mq_xl
    padding-right 220px

  & + .TourQuizzQuestion
    margin-top 30px

    @media $mq_m
      margin-top 6.25vw

  &_question

    font-weight 200
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.035em;
    margin-bottom 10px

    @media $mq_m
      font-size: 20px;
      line-height: 35px;

  &_answer

    padding 10px 20px
    color #4D483E
    cursor pointer
    display table
    text-transform uppercase
    font-size: 14px;
    letter-spacing: 1px;
    text-align: center;
    border 1px solid #4D483E
    border-radius 50px
    margin-top 10px

    -webkit-tap-highlight-color: transparent!important;
    transition all 0.8s $ease

    @media $mq_m
      font-size: 16px;

    &:hover,
    &:focus

      border-color $beige
      color $beige

    &.is-selected

      border-color $beige
      color $black
      background-color $beige

  &_validation
    box-sizing border-box
    display block
    background-color #4D483E
    padding 12px
    text-align center
    margin-top 15px

    @media $mq_xl
      margin-top 0
      position: absolute
      top 50%
      right 0
      transform translate(50%, -50%)
      max-width 400px

    &_wrapper
      border 1px solid $beige
      padding 20px

    &_title
      font-size 14px
      line-height @font-size*1.2
      text-transform uppercase
      letter-spacing: 0.1em

      @media $mq_m
        font-size 18px

    &_sep
      display: block
      width 50px
      height 2px
      background-color currentColor
      margin 20px auto

    &_desc
      font-size 16px
      line-height 32px
      letter-spacing: 0.05em

      @media $mq_m
        font-size 18px
        line-height 40px

    &.quizz-validation-enter,
    &.quizz-validation-leave-to
      opacity: 0
      transform translate(75%, -50%)

      @media $mq_m
        transform translate(0%, 0%)

    &.quizz-validation-enter-active,
    &.quizz-validation-leave-active
      transition all .8s $ease

      @media $mq_m
        transition opacity 1.2s $ease

  &.is-validated
    pointer-events none

  &.is-valid
    .TourQuizzQuestion_validation
      // background-color green

</style>
